/* Copyright (c) 2022 MOCA Systems, Inc.  All rights reserved. */

import { fancyFirebaseGetters, fancyFirebaseReferencer } from '@touchplan/fancy-referencer';
import { logger } from '@touchplan/logging';
import { FancyDatabase, IRefLike } from '@touchplan/common';

// see https://mocasystems.atlassian.net/browse/MOC-4478

export function pokeJustProjectPresence<T extends IRefLike>(
	projectId: string,
	fancyDatabase: FancyDatabase<T>
): Promise<void> {
	const projectPresencePath = fancyFirebaseGetters.getProjectPresencePath(projectId);
	const ref = fancyFirebaseReferencer.getRef(projectPresencePath, projectId);
	return fancyDatabase.update(ref, {
		id: projectId,
		lastUpdate: fancyDatabase.ServerValue.TIMESTAMP,
	});
}

export function pokeJustUserProjectPresence<T extends IRefLike>(
	projectId: string,
	userId: string,
	fancyDatabase: FancyDatabase<T>
): Promise<void> {
	const userProjectPresencePath = fancyFirebaseGetters.getPresencePath(userId, projectId);
	const ref = fancyFirebaseReferencer.getRef(userProjectPresencePath);
	const childRef = fancyDatabase.child(ref, 'lastUpdate');
	return fancyDatabase.set(childRef, fancyDatabase.ServerValue.TIMESTAMP);
}

/** writes a "I'm here" update to the two project presence nodes */
export function pokeProjectPresence<T extends IRefLike>(
	projectId: string,
	userId: string,
	fancyDatabase: FancyDatabase<T>
): Promise<void> {
	if (!projectId || !userId) {
		logger.log('Could not poke project presence. projectId or user id are invalid');
		return Promise.resolve();
	}
	return Promise.all([
		pokeJustProjectPresence(projectId, fancyDatabase),
		pokeJustUserProjectPresence(projectId, userId, fancyDatabase),
	]).then(() => Promise.resolve());
}
